import { FunctionComponent, memo } from "react";
import { SpinnerUntil } from "@edgetier/components";
import AddRoleAction from "components-for/roles/role-actions-menu/add-role-action";
import RoleForm from "components-for/roles/role-form";
import { Page, PageContent, PageHeader } from "@edgetier/client-components";
import PermissionsTable from "./permissions-table";
import usePermissions from "hooks-for/permissions/use-permissions";
import useRoles from "hooks-for/permissions/use-roles";

import { IPermission, IRole } from "@edgetier/watchtower-types";
import { IProps } from "./permissions.types";
import "./permissions.scss";

/**
 * View and edit user roles and permissions
 */
const Permissions: FunctionComponent<IProps> = () => {
    const { data: roles, isLoading: isRolesLoading } = useRoles();
    const { data: permissions, isLoading: isPermissionsLoading } = usePermissions();

    return (
        <Page className="permissions">
            <PageHeader title="Permissions" />
            <PageContent>
                <div className="permissions__header">
                    <AddRoleAction actionLabel="Add role" isButton>
                        {({ closeModal }) => <RoleForm toggleAction={closeModal} />}
                    </AddRoleAction>
                </div>
                <SpinnerUntil<{ roles: IRole[]; permissions: IPermission[] }>
                    data={{ roles, permissions }}
                    isReady={!isRolesLoading && !isPermissionsLoading}
                >
                    {({ roles, permissions }) => <PermissionsTable roles={roles} permissions={permissions} />}
                </SpinnerUntil>
            </PageContent>
        </Page>
    );
};

export default memo(Permissions);
